// Highlighting for code blocks
import "prismjs/themes/prism.css";

export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  if (location.hash || location.action === "POP") {
    return true;
  }

  // A client-side navigation should behave like loading a new document. Keep
  // Gatsby's saved-position behavior only for browser back/forward navigation.
  // Gatsby 5's scroll handler only checks the return value for truthiness;
  // returning coordinates does not actually apply them.
  window.scrollTo(0, 0);
  return false;
};
